import { render, staticRenderFns } from "./AnswersWaitingPlayers.vue?vue&type=template&id=6e643912"
import script from "./AnswersWaitingPlayers.vue?vue&type=script&lang=js"
export * from "./AnswersWaitingPlayers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports